import { render, staticRenderFns } from "./citys.vue?vue&type=template&id=1a458568&scoped=true"
import script from "./citys.vue?vue&type=script&lang=js"
export * from "./citys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a458568",
  null
  
)

export default component.exports